export class StopReconnectingAction {
    constructor() {
        this.name = 'StopReconnecting';
        this.isDeviceAction = true;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3RvcFJlY29ubmVjdGluZ0FjdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvbW9kZWxzL2FjdGlvbnMvU3RvcFJlY29ubmVjdGluZ0FjdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLQSxNQUFNLE9BQU8sc0JBQXNCO0lBQW5DO1FBQ2tCLFNBQUksR0FBRyxrQkFBa0IsQ0FBQztRQUMxQixtQkFBYyxHQUFHLElBQUksQ0FBQztJQUN4QyxDQUFDO0NBQUEifQ==